// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"dacf1bcf","312":"7ffce23e","640":"e3a42323"}[chunkId] + ".chunk.js";
};